/******************
* Create and insert a PopUp (for getting newsletter signups etc.)
*
*
* Documentation: see `popups.README.md`
*
*/

if(typeof FN == 'undefined') FN = {};

FN.popupConfig = {
  configuredItems: {},
  instances: {},
  
  /** Search configuredItems for a popup for _this_ page and then create/init it */
  initConfiguredItems: function(){
    FN.popupConfig.instances = {};
    var popupsForCurrentPage = FN.popupConfig._findActivePopupsForCurrentPage();
    for(var p=0; p<popupsForCurrentPage.length; p++){
      FN.popupConfig.createPopupWithConfig(popupsForCurrentPage[p]);
    }
  },
  
  /** Create a new FN.popup instance and add it */
  createPopupWithConfig: function(popupConfig){
    if(popupConfig.id in FN.popupConfig.instances) return;
    
    FN.popupConfig.instances[popupConfig.id] = new FN.popup(popupConfig);
  },
  
  /** adds a popup configuration */
  addPopupConfig: function(config){
    if(!config) return;
    
    FN.popupConfig.configuredItems[config.id] = config;
  },
  
  /**
    Search FN.popupConfig.configuredItems for an active popup configuration for this page
    Note:   - 'active' must be true
            - 'pagePaths' must contain a regEx that matches the current window.location.pathname
  */
  _findActivePopupsForCurrentPage: function(){
    var popupsForCurrentPage = [];
    for (var key in FN.popupConfig.configuredItems) {
      if(!FN.popupConfig.configuredItems[key].active) continue;
      
      for(var p=0; p<FN.popupConfig.configuredItems[key].pagePaths.length; p++){
        var re = new RegExp(FN.popupConfig.configuredItems[key].pagePaths[p]);
        var match = re.exec(window.location.pathname);
        if(match) popupsForCurrentPage.push(FN.popupConfig.configuredItems[key]);
      }
    }
    
    return popupsForCurrentPage;
  }
};



FN.popup = function(config){
  /**
    Create and initialize a configured popup
  */
  this._initWithConfig = function(popupConfig){
    if(!popupConfig) return false;
    
    this.id = popupConfig.id;
    this.config = popupConfig;
    this.root = null;
    this._scrollHandler = null;
    this._clickHandler = null;
    if(this._checkHasBeenClosedBefore()) return false;

    var html = this._generateHtmlContent();
    html     = this._wrapHtmlContent(html);
    if(!html) return false;
    
    this._insertPopupHtml(html);
    this.root = document.getElementById(this.id);
    this._attachEventHandlers();
    this._manageFirstDisplay();
    
    // add analytics event listeners
    var popupAnalyticsEvents = [
      { 'config': { 'selector': '#' + this.id + ' .fn-popup__newsletter-form.analytics--submit', 'triggerOnlyOnce': true },
        'event':  { 'eventCategory': 'newsletter', 'eventAction': 'signup', 'eventLabelSuffix': this.id }
      },
      { 'config': { 'selector': '#' + this.id + ' .fn-popup__button--link.analytics--click' },
        'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'landing-page', 'eventLabelSuffix': this.id }
      },
      { 'config': { 'selector': '#' + this.id + ' .fn-popup__button--tweet.analytics--click' },
        'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': this.id }
      }
    ];
    if('analytics' in FN) FN.analytics.addConfiguredEvents(popupAnalyticsEvents);
  };
  

  /**
    Insert the generated HTML into the DOM
  */
  this._insertPopupHtml = function(html){
    switch(this.config.type){
      case 'sidebar':
      case 'modal':
      case 'welcome-mat':
        document.body.insertAdjacentHTML('beforeend', html);
        break;
      
      case 'inline':
        document.querySelectorAll('.popup-placeholder').forEach(function(placeholder){
          if(placeholder.dataset.popupId === this.id){
            placeholder.outerHTML = html;
          }
        }, this);
        break;
    }
  };
  
  
  /**
    Wraps the HTML content blocks in HTML containers
  */
  this._wrapHtmlContent = function(contentHtml){
    var html = '';
    html += '<div id="'+ this.id +'" class="fn-popup fn-popup--'+ this.config.type +' fn-popup--hidden">';
    
    switch(this.config.type){
      case 'sidebar':
        html += '<div class="fn-popup__content-container">';
        html += '  <div class="fn-popup__close"></div>';
        html +=    contentHtml;
        html += '</div>';        
        break;
        
      case 'inline':
        html += '<div class="fn-popup__content-container">';
        html += '  <div class="fn-popup__close"></div>';
        html +=    contentHtml;
        html += '</div>';        
        break;
        
      case 'modal':
        html += '<div class="fn-popup__overlay"></div>';
        html += '<div class="fn-popup__content-container">';
        html += '  <div class="fn-popup__close"></div>';
        html +=    contentHtml;
        html += '</div>';        
        break;
        
      case 'welcome-mat':
        html += '<div class="fn-popup__overlay"></div>';
        html += '<div class="fn-popup__close"></div>';
        html += '<div class="fn-popup__content-container">' + contentHtml + '</div>';
        break;
    }

    return html;
  };
  
  
  /**
    Generate appropriate HTML
  */
  this._generateHtmlContent = function(){
    var html = '';
    for(var i=0; i<this.config.content.length; i++){
      var content = this.config.content[i];
      html += '<div class="fn-popup__content fn-popup__content--' + (i+1) + '">';

      switch(content.type){
        case 'content':
          html    += '<div class="fn-popup__text">'+ content['text'] +'</div>';
          html    += '<a class="fn-popup__button fn-popup__button--next">'+ content['action-button'] +'</a>';
          break;

        case 'link':
          html    += '<div class="fn-popup__text">'+ content['text'] +'</div>';
          html    += '<a class="fn-popup__button fn-popup__button--link analytics--click">'+ content['action-button'] +'</a>';
          break;

        case 'tweet':
          html    += '<div class="fn-popup__text">'+ content['text'] +'</div>';
          html    += '<a class="fn-popup__button fn-popup__button--tweet analytics--click">'+ content['action-button'] +'</a>';
          if('footer' in content){
            html    += '<div class="fn-popup__footer">'+ content['footer'] +'</div>';
          }
          break;
          
        case 'newsletter-signup':
          html    += '<div class="fn-popup__text">'+ content['text'] +'</div>';
          html    += '<div class="fn-popup__input">';
          html    += '  <form class="fn-popup__newsletter-form analytics--submit" autocomplete="off">';
          html    += '    <input type="hidden" name="action" value="subscribe" />';
          html    += '    <input type="hidden" name="format" value="json" />';
          html    += '    <input type="hidden" name="listName" value="'+ (content['list-name'] ? content['list-name'] : 'tower') +'" />';
          html    += '    <input type="hidden" name="signup[medium]" value="'+ content['signup-medium'] +'" />';
          html    += '    <input type="hidden" name="signup[URI]" value="'+ content['signup-URI'] +'" />';
          html    += '    <input type="hidden" name="signup[OS]" value="'+ FN.helpers.platform() +'" />';
          if('signup-form' in content){
            html  += '    <input type="hidden" name="signupForm" value="'+ content['signup-form'] +'" />';
          }
          if('tags' in content){
            html += '<div class="newsletter-form__groups">';
            for(var t=0; t<content['tags'].length; t++){
              var hidden = ('hidden' in content['tags'][t] && content['tags'][t]['hidden']) ? ' style="display:none;" ' : '';
              var defaultChecked = ('default' in content['tags'][t] && content['tags'][t]['default']) ? ' checked="checked" ' : '';
              var requiredTag = ('required' in content['tags'][t]) ? content['tags'][t]['required'] : '';
              var cssClass = 'signup-tag__item' + (('collectConsent' in content['tags'][t] && content['tags'][t]['collectConsent']) ? ' consent__text' : '');
              html  += '<div class="row"'+ hidden +'><label>';
              html  +=    '<input class="'+ cssClass +'" type="checkbox" name="tags[]" value="'+ content['tags'][t]['id'] +'" id="signup-tag__'+ content['tags'][t]['id'] +'"'+ defaultChecked +' data-required="'+ requiredTag +'" />';
              html  +=    ('label' in content['tags'][t]) ? content['tags'][t]['label'] : '';
              html  += '</label></div>';
            }
            html += '</div>';
          }
          if('consent' in content){
            html += '<div class="newsletter-form__consent">';
            for(var c=0; c<content['consent'].length; c++){
              html += '<label><input type="checkbox" id="consent--'+ content['consent'][c]['id'] +'" class="consent__item consent__text" data-required="'+ content['consent'][c]['required'] +'" />'+ content['consent'][c]['text'] +'</label>';
            }
            html += '</div>';
          }
          html    += '<div class="newsletter-form__submit">';
          html    +=    '<input type="text" name="email" placeholder="Email Address" />';
          html    +=    '<input type="submit" value="'+ content['action-button'] +'" class="fn-popup__button--signup" />';
          if('close-button' in content){
            html  += '    <a class="fn-popup__button fn-popup__button--close analytics--click">'+ content['close-button'] +'</a>';
          }
          html    += '</div>';
          html    += '    <div class="request-notice"></div>';
          html    += '  </form>';
          html    += '</div>';
          break;
      }
        
      html  += '</div>';
    }

    return html;
  };
  
  
  /**
    Manages the first display of the popup (either when reaching a certain scrolling position or directly after loading the page)
  */
  this._manageFirstDisplay = function(){
    if(this.config.display.event === 'onScroll'){
      this._scrollHandler = this._showOnScroll.bind(this);
      window.addEventListener('scroll', this._scrollHandler);
    }else if(this.config.display.event === 'onLoad'){
      this._showOnLoad();
    }else if(this.config.display.event === 'onClick'){
      this._clickHandler = this._showOnClick.bind(this);
      document.addEventListener('click', this._clickHandler);
    }
  };
  
  
  this._showOnScroll = function() {
    var scrollingPosition = (window.pageYOffset || document.documentElement.scrollTop || 0) + window.innerHeight;

    if("beforeElement" in this.config.display){
      /*    'display': { 
              'event': 'onScroll',              // must be 'onScroll'
              'beforeElement': '#chapter ~',    // CSS selector of the element that the popup should display when reaching
              'withDistance': '500' }           // optional amount of pixels that the event should fire before reaching the element
      */
      var beforeElement = document.querySelector(this.config.display.beforeElement);
      if (!beforeElement) return;
      var offsetTop = beforeElement.getBoundingClientRect().top + window.pageYOffset;
      if("withDistance" in this.config.display) offsetTop -= this.config.display.withDistance;
      if(scrollingPosition > offsetTop){
        this._revealPopup();
        if (this._scrollHandler) window.removeEventListener('scroll', this._scrollHandler);
      }
      
    }else if("percent" in this.config.display){
      /*  'display': { 
            'event': 'onScroll',    // must be 'onScroll'
            'percent': '0.7' }     // scrolling position, 0 to 1 (bottom of page)
      */
      var documentHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      if(scrollingPosition / documentHeight > this.config.display.percent){
        this._revealPopup();
        if (this._scrollHandler) window.removeEventListener('scroll', this._scrollHandler);
      }
    }
  };
  
  
  this._showOnLoad = function(){
    /*    'display': {
            'event': 'onLoad',    // must be 'onLoad'
            'delay': 500 }        // delay in miliseconds
    */
    var thePopup = this;
    setTimeout(function(){
      thePopup._revealPopup();
    }, thePopup.config.display.delay);
  };
  
  
  this._showOnClick = function(event){
    /*    'display': {
            'event': 'onClick',       // must be 'onClick'
            'selector': '.button' }   // CSS selector of the element(s) that should trigger the popup on click
    */
    var clickedElement = event.target.closest(this.config.display.selector);
    if (!clickedElement) return;

    event.preventDefault();
    this._revealPopup();
  };
  
  
  /**
    Reveal (display for the first time) an already created popup
  */
  this._revealPopup = function(){
    var thePopup = this;
    if (!this.root) return;

    if(this.config.type === 'modal'){
      this.root.classList.remove('fn-popup--hidden');
      var modalContent = this.root.querySelector('.fn-popup__content-container');
      if (modalContent) modalContent.style.display = 'block';
      
    }else if(this.config.type === 'welcome-mat'){
      this.root.classList.remove('fn-popup--hidden');
      
    }else if(this.config.type === 'sidebar'){
      if('startSmall' in this.config.display){
        this.root.classList.add('fn-popup--squashed');
      }
      this.root.classList.remove('fn-popup--hidden');
      setTimeout(function(){
        var firstContent = document.querySelector('#' + thePopup.id + ' .fn-popup__content--1');
        if (firstContent) firstContent.style.display = 'block';
      }, 600);
      
    }else if(this.config.type === 'inline'){
      this.root.classList.remove('fn-popup--hidden');
    }
  };
  
  
  /**
    Attach event handlers
  */
  this._attachEventHandlers = function(){
    var self = this;
    if (!this.root) return;

    // --- close popup
    this.root.querySelectorAll('.fn-popup__close, .fn-popup__button--close').forEach(function(item){
      item.addEventListener('click', self.close.bind(self));
    });

    // --- show next content, if any
    this.root.querySelectorAll('.fn-popup__button--next').forEach(function(item){
      item.addEventListener('click', function(event){
        var currentContentOnClick = self._currentContentNumberOnClick(event.target);
        self.nextOrClose(currentContentOnClick);
      });
    });

    // --- open link in new window
    this.root.querySelectorAll('.fn-popup__button--link').forEach(function(item){
      item.addEventListener('click', function(event){
        var currentContentOnClick = self._currentContentNumberOnClick(event.target);
        window.open(self.config.content[currentContentOnClick-1]['url'], '_blank');
        self.nextOrClose(currentContentOnClick);
      });
    });
    
    // --- open tweet window
    this.root.querySelectorAll('.fn-popup__button--tweet').forEach(function(item){
      item.addEventListener('click', function(event){
        var currentContentOnClick = self._currentContentNumberOnClick(event.target);
        var tweetOptions = self.config.content[currentContentOnClick-1]['tweet'];
        FN.socialShare(tweetOptions.platform, tweetOptions.url, tweetOptions.text);
        self.nextOrClose(currentContentOnClick);
      });
    });

    // --- register newsletter element
    var newsletterItem = this.root.querySelector('.fn-popup__newsletter-form');
    if(newsletterItem){
      FN.newsletterConfig.instances.push(new FN.newsletter(newsletterItem));
      document.addEventListener('FN.newsletter:success', function(event){
        var context = event.detail || {};
        var responseContainer = context.options ? context.options.responseContainer : null;
        if (responseContainer && responseContainer.closest('#' + self.id)) {
          self._newsletterSubmissionResponse(context.responseData, context.options);
        }
      });
    }
  };
  
  
  /**
    Shows next content (of multi-step popup contents)
  */
  this._showNextContent = function(currentContentNo){
    var thePopup = this;
    // hide current content
    var currentContent = document.querySelector('#'+ this.id +' .fn-popup__content--' + currentContentNo);
    if (currentContent) currentContent.style.display = 'none';

    // if configured to grow after the first interaction...
    if('startSmall' in this.config.display && this.config.display['startSmall'] == true){
      if(this.root && this.root.classList.contains('fn-popup--squashed')){
        this.root.classList.remove('fn-popup--squashed');
        this.root.classList.add('fn-popup--stretched');
      }
    }

    // show next content
    if(document.querySelector('#'+ this.id +' .fn-popup__content--' + (parseInt(currentContentNo, 10)+1))){
      setTimeout(function(){
        var nextContent = document.querySelector('#'+ thePopup.id +' .fn-popup__content--' + (parseInt(currentContentNo, 10)+1));
        if (nextContent) nextContent.style.display = 'block';
      }, 500);
    }
  };
  
  
  /**
    Returns the number (id) of the currently shown content (typicall, either 1, 2, or 3)
  */
  this._currentContentNumberOnClick = function(clickedItem){
    var contentContainer = clickedItem.closest('.fn-popup__content');
    if (!contentContainer) return false;
    var contentId = (contentContainer.className || '').match(/fn-popup__content--(\d){1}/i);
    if(contentId && contentId[1]){
      return contentId[1];
    }else{
      return false;
    }
  };
  
  
  /**
    Check if a the popup has been closed on a previous pageview
  */
  this._checkHasBeenClosedBefore = function(){
    var re = new RegExp(this.id + "=([^;]+)");
    var value = re.exec(document.cookie);
    return (value !== null) ? true : false;
  };
  
  
  /**
    Save a cookie if the user has closed the popup (so he doesn't see it again on his next visit)
  */
  this._setPreventReopenCookie = function(){
    var expirationDate;
    
    // Check if custom cookie expiration hours are configured
    if('cookieExpirationHours' in this.config.display) {
      var hours = this.config.display.cookieExpirationHours;
      expirationDate = new Date();
      expirationDate.setTime(expirationDate.getTime() + (hours * 60 * 60 * 1000));
    } else {
      // Default to the original long expiration
      expirationDate = new Date('Tue, 07 Nov 2084 12:00:00 GMT');
    }
    
    document.cookie = this.id +'=closed; path=/; expires=' + expirationDate.toUTCString();
  };
  
  
  /**
   Callback for async newsletter requests
  */
  this._newsletterSubmissionResponse = function(data, options){
    if(data && data.status === 200){
      var currentContentOnClick = this._currentContentNumberOnClick(options.responseContainer);
      this.nextOrClose(currentContentOnClick);
    }
  };
  
  
  /**
    Close any open popups
  */
  this.close = function(){
    if (this.root) this.root.classList.add('fn-popup--hidden');
    if('showOnlyOnce' in this.config.display && this.config.display.showOnlyOnce === false){
      // don't set a cookie
    }else{
      this._setPreventReopenCookie();
    }
  };
  
  
  /**
    Show next content or close the popup (if there is no "next" content...)
  */
  this.nextOrClose = function(currentContentNo){
    var numberOfContents = this.config.content.length;
    if(numberOfContents > currentContentNo){
      this._showNextContent(currentContentNo);
    }else if(numberOfContents == currentContentNo){
      this.close();
    }
  }

  /*****************
  * Constructor
  */
  this._initWithConfig(config);
};




// load configured popups - but only once the page is completely loaded
window.addEventListener('load', function(){
  FN.popupConfig.initConfiguredItems();
});
